import { createReducer } from '@reduxjs/toolkit'

import * as actions from '../actions'
import { ISoftionState } from '../types'

const initialState: ISoftionState['data'] = {
  betHistory: {
    count: 0,
    list: [],
  },
  subBet: {},
  activeBet: null,
  playerBalance: 0,
  sessionUrl: null,
  sessionTestUrl: '',
  ticket: {
    placement: null,
    status: null,
  },
}

export default createReducer(initialState, builder => {
  builder
    .addCase(actions.getBetHistory.success, (state, action) => {
      state.betHistory = action.payload
    })
    // .addCase(actions.getSubBet.success, (state, action) => {
    //   state.subBet = { ...state.subBet, [action.payload.id]: action.payload.info }
    // })
    .addCase(actions.changeActiveBet, (state, action) => {
      state.activeBet = action.payload
    })
    .addCase(actions.clearSession.success, state => {
      state.sessionUrl = null
    })
    .addCase(actions.createSession.success, (state, action) => {
      state.sessionUrl = action.payload
    })
})
